import { render, staticRenderFns } from "./avalonMenuFontsEditElement.vue?vue&type=template&id=690f810a&scoped=true&"
import script from "./avalonMenuFontsEditElement.vue?vue&type=script&lang=js&"
export * from "./avalonMenuFontsEditElement.vue?vue&type=script&lang=js&"
import style0 from "./avalonMenuFontsEditElement.vue?vue&type=style&index=0&id=690f810a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f810a",
  null
  
)

export default component.exports